import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { chatKeys } from '../../keys'
import chatService from '../services'

export function useMutationAdminTaskDone(roomId: string) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (taskId: string) => chatService.markAdminTaskDone(taskId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatKeys.adminTasks(roomId) })
		},
		onError: () => {
			toast.error('ไม่สามารถอัปเดตงานได้')
		},
	})
}

export function useMutationAdminTaskDismiss(roomId: string) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (taskId: string) => chatService.dismissAdminTask(taskId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatKeys.adminTasks(roomId) })
		},
		onError: () => {
			toast.error('ไม่สามารถยกเลิกงานได้')
		},
	})
}

export function useMutationAdminTaskReopen(roomId: string) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (taskId: string) => chatService.reopenAdminTask(taskId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatKeys.adminTasks(roomId) })
		},
		onError: () => {
			toast.error('ไม่สามารถเปิดงานใหม่ได้')
		},
	})
}
